import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  Badge,
} from "reactstrap";
import { Link } from "react-router-dom";
import classNames from "classnames";

// Import Charts
import StackedColumnChart from "./StackedColumnChart";
import StackedColumnChartVoyage from "./StackedColumnChart2";
import StackedColumnChartVisa from "./StackedColumnChart3";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// i18n
import { withTranslation } from "react-i18next";
import {
  counthotelreservation,
  countpayement,
  countvoyage,
  getAllreservation,
  getAllvisas,
  getcounte,
  getcounte2,
  getcounte3,
  getmonthly,
  hotelreservationmonthly,
  visamonthly,
  voyagemonthly,
} from "helpers/requests";
import TotalSellngProduct from "./total-selling-product";

const dummyChartsData = [
  { name: "Week 1", value: 4000 },
  { name: "Week 2", value: 3000 },
  { name: "Week 3", value: 2000 },
  { name: "Week 4", value: 2780 },
  { name: "Week 5", value: 1890 },
];

const dummyReportsData = [
  { title: "Propriete", description: 0, iconClass: "bx-copy-alt" },
  { title: "Users", description: "0", iconClass: "bx bx-user" },
  { title: "Visas", description: "0", iconClass: "bx bxl-visa" },
  { title: "Hotel Reservations", description: "0", iconClass: "bx bx-home-circle" },
  { title: "Voyage Reservations", description: "0", iconClass: "bx bxs-plane-take-off " },
  { title: "Payements Done", description: "0", iconClass: "bx bx-credit-card " },
];

const Statistique = (props) => {
  const [modal, setModal] = useState(false);
  const [subscribeModal, setSubscribeModal] = useState(false);
  const [periodData, setPeriodData] = useState(dummyChartsData);
  const [periodType, setPeriodType] = useState("yearly");
  const [reports, setReports] = useState(dummyReportsData);
  const [visas, setVisas] = useState([]);
  const [currentMonthData, setCurrentMonthData] = useState(null);
  const [datamonth, setDatamonth] = useState([]);
  const [monthlyEarnings, setMonthlyEarnings] = useState(0);
  const [currentMonthPercentage, setCurrentMonthPercentage] = useState(0);
  const [reservation, setReseravation] = useState([]);
  const [reservationEarningc, setReservationEarning] = useState(0);
  const [visasearning, setVisasEarning] = useState(0);
  const [monthlyVisa, setmonthlyVisa] = useState(0);
  const [monthlyHotelReservation, setmonthlyHotelReservation] = useState(0);
  const [monthlyVoyage, setmonthlyVoyage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [reservationHistoryModal, setReservationHistoryModal] = useState(false);
  const [reservationHistoryType, setReservationHistoryType] = useState(null); // "accepted" or "refused"
  const [reservationHistory, setReservationHistory] = useState([]);

  // New state for hotel rankings
  const [hotelRankingsByAccepted, setHotelRankingsByAccepted] = useState([]);
  const [hotelRankingsByPrice, setHotelRankingsByPrice] = useState([]);
  const [currentPageAccepted, setCurrentPageAccepted] = useState(1);
  const [currentPagePrice, setCurrentPagePrice] = useState(1);
  const itemsPerPage = 5;

  // Calculate hotel rankings
  const calculateHotelRankings = (monthlyHotelReservation) => {
    const hotelMap = {};

    // Iterate over each month in the monthlyHotelReservation object
    Object.values(monthlyHotelReservation).forEach((reservations) => {
      reservations.forEach((reservation) => {
        const hotelId = reservation.propertyId;

        // Initialize the hotel in the map if it doesn't exist
        if (!hotelMap[hotelId]) {
          hotelMap[hotelId] = {
            name: reservation.property?.name || "Unknown Hotel",
            accepted: 0,
            totalPrice: 0,
          };
        }

        // Update the accepted count and total price for the hotel
        if (reservation.status === "HOTEL_ACCEPTED") {
          hotelMap[hotelId].accepted += 1;
        }
        hotelMap[hotelId].totalPrice += reservation.totalPrice || 0;
      });
    });

    // Convert the map to an array and sort by accepted reservations and total price
    const rankingsByAccepted = Object.values(hotelMap).sort((a, b) => b.accepted - a.accepted);
    const rankingsByPrice = Object.values(hotelMap).sort((a, b) => b.totalPrice - a.totalPrice);

    return { rankingsByAccepted, rankingsByPrice };
  };

  // Pagination logic
  const paginate = (array, page, itemsPerPage) => {
    const startIndex = (page - 1) * itemsPerPage;
    return array.slice(startIndex, startIndex + itemsPerPage);
  };

  useEffect(() => {
    const fetchcounte = async () => {
      try {
        const data = await getcounte();
        const data2 = await getcounte2();
        const data3 = await getcounte3();
        const data4 = await counthotelreservation();
        const data5 = await countvoyage();
        const data6 = await countpayement();

        const monthlyvisa = await visamonthly();
        const monthlyhotel = await hotelreservationmonthly();
        const monthlyvoyage = await voyagemonthly();

        console.log(monthlyhotel);

        setmonthlyHotelReservation(monthlyhotel);
        setmonthlyVisa(monthlyvisa);
        setmonthlyVoyage(monthlyvoyage);

        const datamonth = await getmonthly();
        setDatamonth(datamonth);

        const reservation = await getAllreservation();
        const visas = await getAllvisas();
        setReseravation(reservation);
        setVisas(visas);

        // Calculate hotel rankings
        const { rankingsByAccepted, rankingsByPrice } = calculateHotelRankings(monthlyhotel);
        setHotelRankingsByAccepted(rankingsByAccepted);
        setHotelRankingsByPrice(rankingsByPrice);

        const currentMonth = new Date().toISOString().slice(0, 7);
        const currentData = datamonth.find((data) => data.month === currentMonth);
        setCurrentMonthData(currentData);

        const alldata = [data, data2, data3, data4, data5, data6];
        setReports((prevReports) => {
          return prevReports.map((report, index) => ({
            ...report,
            description: alldata[index] || report.description,
          }));
        });

        const totalEarnings = calculateMonthlyEarnings(reservation, visas);
        setMonthlyEarnings(totalEarnings);
        const percentages = calculateAcceptancePercentage(reservation, visas);
        setCurrentMonthPercentage(percentages);
      } catch (error) {
        console.error("Error fetching count data:", error);
      }
    };
    fetchcounte();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setSubscribeModal(true);
    }, 2000);
  }, []);

  const onChangeChartPeriod = (pType) => {
    setPeriodType(pType);
    setPeriodData(dummyChartsData);
  };

  // Handle search input changes
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    // Generate suggestions based on the query
    if (query) {
      const allHotels = Object.values(monthlyHotelReservation).flat();
      const filteredSuggestions = allHotels
        .filter((reservation) =>
          reservation.property?.name.toLowerCase().includes(query.toLowerCase())
        )
        .map((reservation) => reservation.property?.name)
        .filter((value, index, self) => self.indexOf(value) === index); // Remove duplicates
      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions([]);
    }
  };

  // Handle hotel selection
  const handleHotelSelect = (hotelName) => {
    const selected = Object.values(monthlyHotelReservation)
      .flat()
      .find((reservation) => reservation.property?.name === hotelName);
    setSelectedHotel(selected);
    setSearchQuery(hotelName);
    setSuggestions([]);
  };

  // Handle click on accepted or refused reservations
  const handleReservationHistoryClick = (type) => {
    if (!selectedHotel) return;

    // Filter reservations based on type (accepted or refused)
    const filteredReservations = Object.values(monthlyHotelReservation)
      .flat()
      .filter(
        (res) =>
          res.propertyId === selectedHotel.propertyId &&
          res.status === (type === "accepted" ? "HOTEL_ACCEPTED" : "HOTEL_REFUSED")
      )
      .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)); // Sort by updatedAt

    setReservationHistory(filteredReservations);
    setReservationHistoryType(type);
    setReservationHistoryModal(true);
  };

  // Meta title
  document.title = "Statistique";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Statistiques")} breadcrumbItem={props.t("Statistique")} />

        
          <Row>
            <Col xl="12">
            
              <Row>
                {(reports || [])?.map((report, key) => (
                  <Col md="4" key={"_col_" + key}>
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">
                              {report.title}
                            </p>
                            <h4 className="mb-0">{report.description}</h4>
                          </div>
                          <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                            <span className="avatar-title rounded-circle bg-primary">
                              <i className={"bx " + report.iconClass + " font-size-24"}></i>
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>

              <Row>
                <Col xl='6'>
                  <Card>
                    <CardBody>
                      <div className="d-sm-flex flex-wrap">
                        <h4 className="card-title mb-4">Hotel Reservations</h4>
                        <div className="ms-auto">
                          <ul className="nav nav-pills">
                            <li className="nav-item">
                              <Link to="#" className={classNames({ active: periodType === "yearly" }, "nav-link")}
                                onClick={() => { onChangeChartPeriod("yearly") }} id="one_month">
                                Year
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <StackedColumnChart
                        periodData={periodData}
                        dataColors='["--bs-success", "--bs-danger", "--bs-warning"]'
                        datamonth={monthlyHotelReservation}
                      />
                    </CardBody>
                  </Card>
                </Col>

                <Col xl='6'>
                  <Card>
                    <CardBody>
                      <div className="d-sm-flex flex-wrap">
                        <h4 className="card-title mb-4">Voyage Reservations</h4>
                        <div className="ms-auto">
                          <ul className="nav nav-pills">
                            <li className="nav-item">
                              <Link to="#" className={classNames({ active: periodType === "yearly" }, "nav-link")}
                                onClick={() => { onChangeChartPeriod("yearly") }} id="one_month">
                                Year
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <StackedColumnChartVoyage
                        periodData={periodData}
                        dataColors='["--bs-success", "--bs-primary", "--bs-danger"]'
                        datamonth={monthlyVoyage}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <Row>
                <TotalSellngProduct
                  monthlyHotelReservation={monthlyHotelReservation}
                  monthlyVisa={monthlyVisa}
                  monthlyVoyage={monthlyVoyage}
                />

                <Col xl='8'>
                  <Card>
                    <CardBody>
                      <div className="d-sm-flex flex-wrap">
                        <h4 className="card-title mb-4">Visa</h4>
                        <div className="ms-auto">
                          <ul className="nav nav-pills">
                            <li className="nav-item">
                              <Link to="#" className={classNames({ active: periodType === "yearly" }, "nav-link")}
                                onClick={() => { onChangeChartPeriod("yearly") }} id="one_month">
                                Year
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <StackedColumnChartVisa
                        periodData={periodData}
                        dataColors='["--bs-success", "--bs-warning", "--bs-danger"]'
                        datamonth={monthlyVisa}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              {/* New Section: Hotel Rankings */}
              <Row>
                <Col xl="6">
                  <Card>
                    <CardBody>
                      <h4 className="card-title mb-4">Top Hotels by Accepted Reservations</h4>
                      <Table>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Hotel Name</th>
                            <th>Accepted Reservations</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginate(hotelRankingsByAccepted, currentPageAccepted, itemsPerPage).map((hotel, index) => (
                            <tr key={index}>
                              <td>{(currentPageAccepted - 1) * itemsPerPage + index + 1}</td>
                              <td>{hotel.name}</td>
                              <td>{hotel.accepted}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <Pagination>
                        {Array.from({ length: Math.ceil(hotelRankingsByAccepted.length / itemsPerPage) }, (_, i) => (
                          <PaginationItem key={i} active={i + 1 === currentPageAccepted}>
                            <PaginationLink onClick={() => setCurrentPageAccepted(i + 1)}>
                              {i + 1}
                            </PaginationLink>
                          </PaginationItem>
                        ))}
                      </Pagination>
                    </CardBody>
                  </Card>
                </Col>

                <Col xl="6">
                  <Card>
                    <CardBody>
                      <h4 className="card-title mb-4">Top Hotels by Total Reservation Price</h4>
                      <Table>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Hotel Name</th>
                            <th>Total Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginate(hotelRankingsByPrice, currentPagePrice, itemsPerPage).map((hotel, index) => (
                            <tr key={index}>
                              <td>{(currentPagePrice - 1) * itemsPerPage + index + 1}</td>
                              <td>{hotel.name}</td>
                              <td>{hotel.totalPrice}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <Pagination>
                        {Array.from({ length: Math.ceil(hotelRankingsByPrice.length / itemsPerPage) }, (_, i) => (
                          <PaginationItem key={i} active={i + 1 === currentPagePrice}>
                            <PaginationLink onClick={() => setCurrentPagePrice(i + 1)}>
                              {i + 1}
                            </PaginationLink>
                          </PaginationItem>
                        ))}
                      </Pagination>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              

            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Statistique.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Statistique);